"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompareOptions = exports.useUnitOptions = exports.useFuelOptions = void 0;
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
// Not sure why this is needed here.
i18next_1.default.use(react_i18next_1.initReactI18next).init({
    lng: 'en',
    resources: {},
    interpolation: {
        escapeValue: false,
    },
    fallbackNS: 'cp-ui-tools',
});
var useFuelOptions = function (options) {
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var fuelLabels = {
        electricity: copy('elecLabel'),
        gas: copy('gasLabel'),
        both: copy('bothFuelsLabel'),
    };
    return options.length > 1
        ? options.map(function (value) { return ({
            value: value,
            label: fuelLabels[value],
        }); })
        : [];
};
exports.useFuelOptions = useFuelOptions;
var useUnitOptions = function (options) {
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var unitLabels = {
        kwh: copy('kwhLabel'),
        pounds: copy('costLabel'),
    };
    return options.length > 1
        ? options.map(function (value) { return ({
            value: value,
            label: unitLabels[value],
        }); })
        : [];
};
exports.useUnitOptions = useUnitOptions;
var useCompareOptions = function (options) {
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var comparisonLabels = {
        noComparison: copy('comparisonOptionNoComparison'),
        previousYear: copy('comparisonOptionPreviousYear'),
        oneMonthEarlier: copy('comparisonOptionOneMonthEarlier'),
        sameMonthLastYear: copy('comparisonOptionSameMonthLastYear'),
    };
    return options.length
        ? __spreadArray(['noComparison'], __read(options), false).map(function (value) { return ({
            value: value,
            label: comparisonLabels[value],
        }); })
        : [];
};
exports.useCompareOptions = useCompareOptions;
